import type {ReactElement} from 'react';
import React from 'react';
import type {UserInfoItemProps} from './user-info-item.types';
import styles from './user-info-item.module.scss';
import {Text, TextSize} from '@Components/text';

export function UserInfoItem({
  profilePictureURL,
  primaryText,
  secondaryText,
  subText,
  actions,
  className = '',
  textContainerClassName = '',
  actionsContainerClassName = '',
  isListItem = false,
}: UserInfoItemProps): ReactElement<any> {
  const containerClassName = `flex-row-align-center ${styles.containerGap} ${className}`;

  const getInnerContent = (): ReactElement<any> => {
    return (
      <>
        <div className="radius-round flex-center _overflow-hidden">
          <img src={profilePictureURL} alt={primaryText} className={`radius-round ${styles.profilePictureImage}`} aria-hidden="true" />
        </div>

        <div className={`flex-1 flex-v-row ${textContainerClassName} _overflow-hidden`}>
          <div className="flex-row-align-center _full-width _overflow-hidden">
            <Text val={primaryText} className="content-body -truncated-text" size={TextSize.XSMALL} bold={!!subText} />
            {secondaryText ? <Text val={secondaryText} className={`content-disabled ${styles.secondaryText}`} size={TextSize.XSMALL} /> : null}
          </div>

          {subText ? <Text val={subText} className="content-body -truncated-text" size={TextSize.XSMALL} /> : null}
        </div>
        {actions ? <div className={`flexbox ${actionsContainerClassName}`}>{actions}</div> : null}
      </>
    );
  };

  if (isListItem) {
    return <li className={containerClassName}>{getInnerContent()}</li>;
  }

  return <div className={containerClassName}>{getInnerContent()}</div>;
}
